import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CommonResponse } from '../models';
import { Language, Vocabulary } from '../models/vocabulary/vocabulary';
import { SUPPORTED_LANG_CODES } from 'app/config/languages.config';
import { buildPaginatedParams, PaginatedRequest } from '../models/request';
import { PaginatedResponse } from '../models/response';

@Injectable({
	providedIn: 'root',
})
export class VocabularyService {
	/**
	 * Language codes actually backed by vocabulary data, as reported by the backend
	 * (the single source of truth). Defaults to the static frontend config until
	 * `getSupportedLanguages()` resolves, so the app still works if the call fails.
	 */
	public supportedLangCodes: string[] = SUPPORTED_LANG_CODES;

	constructor(private _http: HttpClient) {}

	getVocabulary(request: PaginatedRequest = {}): Observable<PaginatedResponse<Language>> {
		return this._http.get<PaginatedResponse<Language>>(`/vocabularies`, {
			params: buildPaginatedParams(request),
		});
	}

	getSupportedLanguages(): Observable<CommonResponse<string[]>> {
		return this._http
			.get<CommonResponse<string[]>>(`/vocabularies/languages`)
			.pipe(tap(res => (this.supportedLangCodes = res?.data?.length ? res.data : SUPPORTED_LANG_CODES)));
	}

	getVocabularyByLanguage(language: string): Observable<CommonResponse<Array<Vocabulary>>> {
		return this._http.get<CommonResponse<Array<Vocabulary>>>(`/vocabularies/${language}`);
	}

	createVocabulary(key: string): Observable<boolean> {
		return this._http.post<boolean>(`/vocabularies`, { key: key });
	}

	updateVocabulary(vocabulary: Vocabulary): Observable<CommonResponse<Vocabulary>> {
		return this._http.patch<CommonResponse<Vocabulary>>(`/vocabularies/${vocabulary._id}`, vocabulary);
	}

	massDestroyVocabulary(vocabulary_ids: Array<string>): Observable<CommonResponse<boolean>> {
		return this._http.delete<CommonResponse<boolean>>(`/vocabularies/mass_destroy`, { body: { vocabulary_ids } });
	}
}
